module.exports = __webpack_public_path__ + "static/media/certificado_assinatura2.f1ff8963.png";